export default "# Please log in\n\nThis page is only for people we know.\n"